import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';

@JsonObject('BannerFilter')
export class BannerFilter extends Entity {
  @JsonProperty('keyword', [String])
  public keyword: string[] = [];
  @JsonProperty('geoLocation', [String])
  public geoLocation: string[] = [];
  @JsonProperty('operatingSector', [String])
  public operatingSector: string[] = [];
  @JsonProperty('date', [String])
  public date: string[] = [];
  @JsonProperty('orderBy', [String])
  public orderBy: string[] = [];
  @JsonProperty('direction', [String])
  public direction: string[] = [];
}
